import { createSlice } from "@reduxjs/toolkit";

import constants from "../../utils/constants";

const initialState = {
  branchesInfo: {},
  requestType: constants.REQUEST_TYPES.INQUIRY,
  bookingStatus: null,
  notQualifiedMessage: "",
  clientDetails: {
    meetingId: null,
    selectedBranch: null,
    firstName: "",
    middleName: "",
    lastName: "",
    phone: "",
    email: "",
    meetingType: constants.MEETING_TYPES.NOT_SELECTED,
    meetingDateTime: null,
    meetingEndDateTime: null,
    additionalInfo: {},
  },
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    updateBranchesInfo(state, action) {
      state.branchesInfo = action.payload;
    },
    updateRequestType(state, action) {
      state.requestType = action.payload;
    },
    updateStatus(state, action) {
      state.bookingStatus = action.payload;
    },
    updateNotQualifiedMessage(state, action) {
      state.notQualifiedMessage = action.payload;
    },
    updateClientDetails(state, action) {
      state.clientDetails = { ...state.clientDetails, ...action.payload };
    },
  },
});

export const bookingActions = bookingSlice.actions;

export default bookingSlice.reducer;
